// Teste AB temporário
window.addEventListener('stars:loaded', () => {
	const currentPage = window.location.pathname;
	const param = window.location.search;
	if(currentPage === '/collections/all' && param.indexOf('testeab=buybutton-comprar') > -1){
		const allbutons = document.querySelectorAll('.product-item__cta.button.button--primary');
		allbutons.forEach((item) => {
			item.querySelector('.cta-text').innerHTML = 'COMPRAR';
		});
	}
});

window.addEventListener('load', () => {

	const queryString = window.location.search;
	
	const urlParams = new URLSearchParams(queryString);
	
	const anchor = urlParams.get('anchor');
	
	if(anchor) {
		const pageHeight = document.querySelector('.product-facet').offsetTop-120;
		window.scroll({
			top: pageHeight,
			behavior: 'smooth'
		});
	}
	
});
